module.exports = __webpack_public_path__ + "static/media/DBC.09ed1192.svg";